// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ClaimDTO } from '../models';
import { ClaimDeletionPreviewDto } from '../models';
import { ClaimWithCheckoutRelationsDTO } from '../models';
import { CreateClaimActivityDTO } from '../models';
import { CreateClaimDTO } from '../models';
import { DeactivateClaimDTO } from '../models';
import { PayClaimDTO } from '../models';
import { ReopenClaimDTO } from '../models';
import { RequestInfoClaimDTO } from '../models';
import { ResolveClaimDTO } from '../models';
import { SearchClaimResultsDTO } from '../models';
import { SubmitMoreInfoClaimDTO } from '../models';
import { UpdateAutoChargeClaimDTO } from '../models';
import { UpdateClaimDTO } from '../models';
import { UpdateTenantDisputeMessageDTO } from '../models';
/**
 * ClaimsApi - axios parameter creator
 * @export
 */
export const ClaimsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Acknowledge that the case has been sent to the insurer
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeCaseSentToInsurer(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling acknowledgeCaseSentToInsurer.');
            }
            const localVarPath = `/v2/claims/{claimId}/acknowledge-case-sent-to-insurer`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Approve a Claim
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveClaim(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling approveClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}/approve`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Claim
         * @param {CreateClaimDTO} createClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaim(createClaimDTO: CreateClaimDTO, options: any = {}): RequestArgs {
            // verify required parameter 'createClaimDTO' is not null or undefined
            if (createClaimDTO === null || createClaimDTO === undefined) {
                throw new RequiredError('createClaimDTO','Required parameter createClaimDTO was null or undefined when calling createClaim.');
            }
            const localVarPath = `/v2/claims`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateClaimDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createClaimDTO !== undefined ? createClaimDTO : {}) : (createClaimDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Capture tenant activity on claim proposal pages
         * @param {string} claimId Claim id
         * @param {CreateClaimActivityDTO} createClaimActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimActivity(claimId: string, createClaimActivityDTO: CreateClaimActivityDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling createClaimActivity.');
            }
            // verify required parameter 'createClaimActivityDTO' is not null or undefined
            if (createClaimActivityDTO === null || createClaimActivityDTO === undefined) {
                throw new RequiredError('createClaimActivityDTO','Required parameter createClaimActivityDTO was null or undefined when calling createClaimActivity.');
            }
            const localVarPath = `/v2/claims/{claimId}/activity`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateClaimActivityDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createClaimActivityDTO !== undefined ? createClaimActivityDTO : {}) : (createClaimActivityDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an Insurance Claim on a policy for an existing Claim
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInsuranceClaimOnClaim(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling createInsuranceClaimOnClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}/insurance-claim`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a Claim as Deactivated
         * @param {string} claimId Claim id 
         * @param {DeactivateClaimDTO} deactivateClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateClaim(claimId: string, deactivateClaimDTO: DeactivateClaimDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling deactivateClaim.');
            }
            // verify required parameter 'deactivateClaimDTO' is not null or undefined
            if (deactivateClaimDTO === null || deactivateClaimDTO === undefined) {
                throw new RequiredError('deactivateClaimDTO','Required parameter deactivateClaimDTO was null or undefined when calling deactivateClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}/deactivate`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"DeactivateClaimDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deactivateClaimDTO !== undefined ? deactivateClaimDTO : {}) : (deactivateClaimDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Decline a Claim
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineClaim(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling declineClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}/decline`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a draft, first-round unanswered awaiting-respondents, or deactivated claim and its related records.
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaim(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling deleteClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Claim By Id
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimById(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling findClaimById.');
            }
            const localVarPath = `/v2/claims/{claimId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a PDF ADR form and sends a message to slack
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateADRForm(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling generateADRForm.');
            }
            const localVarPath = `/v2/claims/{claimId}/adr-form`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Optimised search for Claims
         * @param {string} organizationId Organization Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} [query] Search query
         * @param {string} [claimStatus] Claim Status to filter by
         * @param {string} [sortBy] Sort By to filter by
         * @param {boolean} [includeDeleted] Include deleted claims
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimisedSearchClaim(organizationId: string, page: number, size: number, query?: string, claimStatus?: string, sortBy?: string, includeDeleted?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling optimisedSearchClaim.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling optimisedSearchClaim.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling optimisedSearchClaim.');
            }
            const localVarPath = `/v2/claims/optimised-search`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (claimStatus !== undefined) {
                localVarQueryParameter['claimStatus'] = claimStatus;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Set payment date for an existing claim
         * @param {string} claimId Claim id 
         * @param {PayClaimDTO} payClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paySupplier(claimId: string, payClaimDTO: PayClaimDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling paySupplier.');
            }
            // verify required parameter 'payClaimDTO' is not null or undefined
            if (payClaimDTO === null || payClaimDTO === undefined) {
                throw new RequiredError('payClaimDTO','Required parameter payClaimDTO was null or undefined when calling paySupplier.');
            }
            const localVarPath = `/v2/claims/{claimId}/pay-supplier`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"PayClaimDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(payClaimDTO !== undefined ? payClaimDTO : {}) : (payClaimDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Dry-run a claim deletion: returns what would be deleted and any blocking reasons.
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewClaimDeletion(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling previewClaimDeletion.');
            }
            const localVarPath = `/v2/claims/{claimId}/deletion-preview`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish a Claim on a Tenancy Checkout
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishClaim(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling publishClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}/publish`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a Claim as ready for Arbitration
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readyForArbitrateClaim(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling readyForArbitrateClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}/arbitration-ready`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Reopen a claim
         * @param {string} claimId Claim id 
         * @param {ReopenClaimDTO} reopenClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenClaim(claimId: string, reopenClaimDTO: ReopenClaimDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling reopenClaim.');
            }
            // verify required parameter 'reopenClaimDTO' is not null or undefined
            if (reopenClaimDTO === null || reopenClaimDTO === undefined) {
                throw new RequiredError('reopenClaimDTO','Required parameter reopenClaimDTO was null or undefined when calling reopenClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}/reopen`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ReopenClaimDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reopenClaimDTO !== undefined ? reopenClaimDTO : {}) : (reopenClaimDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Request more from information on a Claim
         * @param {string} claimId Claim id 
         * @param {RequestInfoClaimDTO} requestInfoClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestMoreInfoClaim(claimId: string, requestInfoClaimDTO: RequestInfoClaimDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling requestMoreInfoClaim.');
            }
            // verify required parameter 'requestInfoClaimDTO' is not null or undefined
            if (requestInfoClaimDTO === null || requestInfoClaimDTO === undefined) {
                throw new RequiredError('requestInfoClaimDTO','Required parameter requestInfoClaimDTO was null or undefined when calling requestMoreInfoClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}/request-more-info`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"RequestInfoClaimDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestInfoClaimDTO !== undefined ? requestInfoClaimDTO : {}) : (requestInfoClaimDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a Claim as Resolved
         * @param {string} claimId Claim id 
         * @param {ResolveClaimDTO} resolveClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveClaim(claimId: string, resolveClaimDTO: ResolveClaimDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling resolveClaim.');
            }
            // verify required parameter 'resolveClaimDTO' is not null or undefined
            if (resolveClaimDTO === null || resolveClaimDTO === undefined) {
                throw new RequiredError('resolveClaimDTO','Required parameter resolveClaimDTO was null or undefined when calling resolveClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}/resolve`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ResolveClaimDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(resolveClaimDTO !== undefined ? resolveClaimDTO : {}) : (resolveClaimDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Skip Evidence Chaser for a claim
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipEvidenceChaser(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling skipEvidenceChaser.');
            }
            const localVarPath = `/v2/claims/{claimId}/skip-evidence-chaser`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit more from information on a Claim
         * @param {string} claimId Claim id 
         * @param {SubmitMoreInfoClaimDTO} submitMoreInfoClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMoreInfoClaim(claimId: string, submitMoreInfoClaimDTO: SubmitMoreInfoClaimDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling submitMoreInfoClaim.');
            }
            // verify required parameter 'submitMoreInfoClaimDTO' is not null or undefined
            if (submitMoreInfoClaimDTO === null || submitMoreInfoClaimDTO === undefined) {
                throw new RequiredError('submitMoreInfoClaimDTO','Required parameter submitMoreInfoClaimDTO was null or undefined when calling submitMoreInfoClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}/submit-more-info`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"SubmitMoreInfoClaimDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(submitMoreInfoClaimDTO !== undefined ? submitMoreInfoClaimDTO : {}) : (submitMoreInfoClaimDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Set Auto Charge Value For Claim
         * @param {string} claimId Claim id 
         * @param {UpdateAutoChargeClaimDTO} updateAutoChargeClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAutoCharge(claimId: string, updateAutoChargeClaimDTO: UpdateAutoChargeClaimDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling updateAutoCharge.');
            }
            // verify required parameter 'updateAutoChargeClaimDTO' is not null or undefined
            if (updateAutoChargeClaimDTO === null || updateAutoChargeClaimDTO === undefined) {
                throw new RequiredError('updateAutoChargeClaimDTO','Required parameter updateAutoChargeClaimDTO was null or undefined when calling updateAutoCharge.');
            }
            const localVarPath = `/v2/claims/{claimId}/update-auto-charge`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateAutoChargeClaimDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateAutoChargeClaimDTO !== undefined ? updateAutoChargeClaimDTO : {}) : (updateAutoChargeClaimDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Claim
         * @param {string} claimId Claim id 
         * @param {UpdateClaimDTO} updateClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaim(claimId: string, updateClaimDTO: UpdateClaimDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling updateClaim.');
            }
            // verify required parameter 'updateClaimDTO' is not null or undefined
            if (updateClaimDTO === null || updateClaimDTO === undefined) {
                throw new RequiredError('updateClaimDTO','Required parameter updateClaimDTO was null or undefined when calling updateClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateClaimDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateClaimDTO !== undefined ? updateClaimDTO : {}) : (updateClaimDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the tenant dispute message on a claim
         * @param {string} claimId Claim id
         * @param {UpdateTenantDisputeMessageDTO} updateTenantDisputeMessageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantDisputeMessage(claimId: string, updateTenantDisputeMessageDTO: UpdateTenantDisputeMessageDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling updateTenantDisputeMessage.');
            }
            // verify required parameter 'updateTenantDisputeMessageDTO' is not null or undefined
            if (updateTenantDisputeMessageDTO === null || updateTenantDisputeMessageDTO === undefined) {
                throw new RequiredError('updateTenantDisputeMessageDTO','Required parameter updateTenantDisputeMessageDTO was null or undefined when calling updateTenantDisputeMessage.');
            }
            const localVarPath = `/v2/claims/{claimId}/tenant-dispute-message`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateTenantDisputeMessageDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateTenantDisputeMessageDTO !== undefined ? updateTenantDisputeMessageDTO : {}) : (updateTenantDisputeMessageDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Substantiate a Claim on a Tenancy Checkout, before going to the insurer or adjudication 
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyClaim(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling verifyClaim.');
            }
            const localVarPath = `/v2/claims/{claimId}/substantiate`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Waive the Admin Fee for disputing a Claim
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waiveDisputeFee(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling waiveDisputeFee.');
            }
            const localVarPath = `/v2/claims/{claimId}/waive-dispute-fee`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a zip of all the documents on a claim and sends a message to slack
         * @param {'ADR' | 'INSURER'} type Zip type
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zipDocuments(type: 'ADR' | 'INSURER', claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling zipDocuments.');
            }
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling zipDocuments.');
            }
            const localVarPath = `/v2/claims/{claimId}/zip-documents`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimsApi - functional programming interface
 * @export
 */
export const ClaimsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Acknowledge that the case has been sent to the insurer
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeCaseSentToInsurer(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).acknowledgeCaseSentToInsurer(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Approve a Claim
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveClaim(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).approveClaim(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create a Claim
         * @param {CreateClaimDTO} createClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaim(createClaimDTO: CreateClaimDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).createClaim(createClaimDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Capture tenant activity on claim proposal pages
         * @param {string} claimId Claim id
         * @param {CreateClaimActivityDTO} createClaimActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimActivity(claimId: string, createClaimActivityDTO: CreateClaimActivityDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).createClaimActivity(claimId, createClaimActivityDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create an Insurance Claim on a policy for an existing Claim
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInsuranceClaimOnClaim(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).createInsuranceClaimOnClaim(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Mark a Claim as Deactivated
         * @param {string} claimId Claim id 
         * @param {DeactivateClaimDTO} deactivateClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateClaim(claimId: string, deactivateClaimDTO: DeactivateClaimDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).deactivateClaim(claimId, deactivateClaimDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Decline a Claim
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineClaim(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).declineClaim(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a draft, first-round unanswered awaiting-respondents, or deactivated claim and its related records.
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaim(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).deleteClaim(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get Claim By Id
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimById(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimWithCheckoutRelationsDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).findClaimById(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Generates a PDF ADR form and sends a message to slack
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateADRForm(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).generateADRForm(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Optimised search for Claims
         * @param {string} organizationId Organization Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} [query] Search query
         * @param {string} [claimStatus] Claim Status to filter by
         * @param {string} [sortBy] Sort By to filter by
         * @param {boolean} [includeDeleted] Include deleted claims
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimisedSearchClaim(organizationId: string, page: number, size: number, query?: string, claimStatus?: string, sortBy?: string, includeDeleted?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchClaimResultsDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).optimisedSearchClaim(organizationId, page, size, query, claimStatus, sortBy, includeDeleted, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set payment date for an existing claim
         * @param {string} claimId Claim id 
         * @param {PayClaimDTO} payClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paySupplier(claimId: string, payClaimDTO: PayClaimDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).paySupplier(claimId, payClaimDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Dry-run a claim deletion: returns what would be deleted and any blocking reasons.
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewClaimDeletion(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDeletionPreviewDto> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).previewClaimDeletion(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Publish a Claim on a Tenancy Checkout
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishClaim(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).publishClaim(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set a Claim as ready for Arbitration
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readyForArbitrateClaim(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).readyForArbitrateClaim(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Reopen a claim
         * @param {string} claimId Claim id 
         * @param {ReopenClaimDTO} reopenClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenClaim(claimId: string, reopenClaimDTO: ReopenClaimDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimWithCheckoutRelationsDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).reopenClaim(claimId, reopenClaimDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Request more from information on a Claim
         * @param {string} claimId Claim id 
         * @param {RequestInfoClaimDTO} requestInfoClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestMoreInfoClaim(claimId: string, requestInfoClaimDTO: RequestInfoClaimDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).requestMoreInfoClaim(claimId, requestInfoClaimDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Mark a Claim as Resolved
         * @param {string} claimId Claim id 
         * @param {ResolveClaimDTO} resolveClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveClaim(claimId: string, resolveClaimDTO: ResolveClaimDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).resolveClaim(claimId, resolveClaimDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Skip Evidence Chaser for a claim
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipEvidenceChaser(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).skipEvidenceChaser(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Submit more from information on a Claim
         * @param {string} claimId Claim id 
         * @param {SubmitMoreInfoClaimDTO} submitMoreInfoClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMoreInfoClaim(claimId: string, submitMoreInfoClaimDTO: SubmitMoreInfoClaimDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).submitMoreInfoClaim(claimId, submitMoreInfoClaimDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set Auto Charge Value For Claim
         * @param {string} claimId Claim id 
         * @param {UpdateAutoChargeClaimDTO} updateAutoChargeClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAutoCharge(claimId: string, updateAutoChargeClaimDTO: UpdateAutoChargeClaimDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).updateAutoCharge(claimId, updateAutoChargeClaimDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a Claim
         * @param {string} claimId Claim id 
         * @param {UpdateClaimDTO} updateClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaim(claimId: string, updateClaimDTO: UpdateClaimDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).updateClaim(claimId, updateClaimDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update the tenant dispute message on a claim
         * @param {string} claimId Claim id
         * @param {UpdateTenantDisputeMessageDTO} updateTenantDisputeMessageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantDisputeMessage(claimId: string, updateTenantDisputeMessageDTO: UpdateTenantDisputeMessageDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).updateTenantDisputeMessage(claimId, updateTenantDisputeMessageDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Substantiate a Claim on a Tenancy Checkout, before going to the insurer or adjudication 
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyClaim(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).verifyClaim(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Waive the Admin Fee for disputing a Claim
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waiveDisputeFee(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDTO> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).waiveDisputeFee(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Generates a zip of all the documents on a claim and sends a message to slack
         * @param {'ADR' | 'INSURER'} type Zip type
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zipDocuments(type: 'ADR' | 'INSURER', claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).zipDocuments(type, claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClaimsApi - factory interface
 * @export
 */
export const ClaimsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Acknowledge that the case has been sent to the insurer
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeCaseSentToInsurer(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).acknowledgeCaseSentToInsurer(claimId, options)(axios, basePath);
        },
        /**
         * Approve a Claim
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveClaim(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).approveClaim(claimId, options)(axios, basePath);
        },
        /**
         * Create a Claim
         * @param {CreateClaimDTO} createClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaim(createClaimDTO: CreateClaimDTO, options?: any) {
            return ClaimsApiFp(configuration).createClaim(createClaimDTO, options)(axios, basePath);
        },
        /**
         * Capture tenant activity on claim proposal pages
         * @param {string} claimId Claim id
         * @param {CreateClaimActivityDTO} createClaimActivityDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimActivity(claimId: string, createClaimActivityDTO: CreateClaimActivityDTO, options?: any) {
            return ClaimsApiFp(configuration).createClaimActivity(claimId, createClaimActivityDTO, options)(axios, basePath);
        },
        /**
         * Create an Insurance Claim on a policy for an existing Claim
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInsuranceClaimOnClaim(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).createInsuranceClaimOnClaim(claimId, options)(axios, basePath);
        },
        /**
         * Mark a Claim as Deactivated
         * @param {string} claimId Claim id 
         * @param {DeactivateClaimDTO} deactivateClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateClaim(claimId: string, deactivateClaimDTO: DeactivateClaimDTO, options?: any) {
            return ClaimsApiFp(configuration).deactivateClaim(claimId, deactivateClaimDTO, options)(axios, basePath);
        },
        /**
         * Decline a Claim
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineClaim(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).declineClaim(claimId, options)(axios, basePath);
        },
        /**
         * Delete a draft, first-round unanswered awaiting-respondents, or deactivated claim and its related records.
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaim(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).deleteClaim(claimId, options)(axios, basePath);
        },
        /**
         * Get Claim By Id
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimById(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).findClaimById(claimId, options)(axios, basePath);
        },
        /**
         * Generates a PDF ADR form and sends a message to slack
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateADRForm(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).generateADRForm(claimId, options)(axios, basePath);
        },
        /**
         * Optimised search for Claims
         * @param {string} organizationId Organization Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} [query] Search query
         * @param {string} [claimStatus] Claim Status to filter by
         * @param {string} [sortBy] Sort By to filter by
         * @param {boolean} [includeDeleted] Include deleted claims
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimisedSearchClaim(organizationId: string, page: number, size: number, query?: string, claimStatus?: string, sortBy?: string, includeDeleted?: boolean, options?: any) {
            return ClaimsApiFp(configuration).optimisedSearchClaim(organizationId, page, size, query, claimStatus, sortBy, includeDeleted, options)(axios, basePath);
        },
        /**
         * Set payment date for an existing claim
         * @param {string} claimId Claim id 
         * @param {PayClaimDTO} payClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paySupplier(claimId: string, payClaimDTO: PayClaimDTO, options?: any) {
            return ClaimsApiFp(configuration).paySupplier(claimId, payClaimDTO, options)(axios, basePath);
        },
        /**
         * Dry-run a claim deletion: returns what would be deleted and any blocking reasons.
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewClaimDeletion(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).previewClaimDeletion(claimId, options)(axios, basePath);
        },
        /**
         * Publish a Claim on a Tenancy Checkout
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishClaim(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).publishClaim(claimId, options)(axios, basePath);
        },
        /**
         * Set a Claim as ready for Arbitration
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readyForArbitrateClaim(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).readyForArbitrateClaim(claimId, options)(axios, basePath);
        },
        /**
         * Reopen a claim
         * @param {string} claimId Claim id 
         * @param {ReopenClaimDTO} reopenClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenClaim(claimId: string, reopenClaimDTO: ReopenClaimDTO, options?: any) {
            return ClaimsApiFp(configuration).reopenClaim(claimId, reopenClaimDTO, options)(axios, basePath);
        },
        /**
         * Request more from information on a Claim
         * @param {string} claimId Claim id 
         * @param {RequestInfoClaimDTO} requestInfoClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestMoreInfoClaim(claimId: string, requestInfoClaimDTO: RequestInfoClaimDTO, options?: any) {
            return ClaimsApiFp(configuration).requestMoreInfoClaim(claimId, requestInfoClaimDTO, options)(axios, basePath);
        },
        /**
         * Mark a Claim as Resolved
         * @param {string} claimId Claim id 
         * @param {ResolveClaimDTO} resolveClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveClaim(claimId: string, resolveClaimDTO: ResolveClaimDTO, options?: any) {
            return ClaimsApiFp(configuration).resolveClaim(claimId, resolveClaimDTO, options)(axios, basePath);
        },
        /**
         * Skip Evidence Chaser for a claim
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipEvidenceChaser(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).skipEvidenceChaser(claimId, options)(axios, basePath);
        },
        /**
         * Submit more from information on a Claim
         * @param {string} claimId Claim id 
         * @param {SubmitMoreInfoClaimDTO} submitMoreInfoClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMoreInfoClaim(claimId: string, submitMoreInfoClaimDTO: SubmitMoreInfoClaimDTO, options?: any) {
            return ClaimsApiFp(configuration).submitMoreInfoClaim(claimId, submitMoreInfoClaimDTO, options)(axios, basePath);
        },
        /**
         * Set Auto Charge Value For Claim
         * @param {string} claimId Claim id 
         * @param {UpdateAutoChargeClaimDTO} updateAutoChargeClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAutoCharge(claimId: string, updateAutoChargeClaimDTO: UpdateAutoChargeClaimDTO, options?: any) {
            return ClaimsApiFp(configuration).updateAutoCharge(claimId, updateAutoChargeClaimDTO, options)(axios, basePath);
        },
        /**
         * Update a Claim
         * @param {string} claimId Claim id 
         * @param {UpdateClaimDTO} updateClaimDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClaim(claimId: string, updateClaimDTO: UpdateClaimDTO, options?: any) {
            return ClaimsApiFp(configuration).updateClaim(claimId, updateClaimDTO, options)(axios, basePath);
        },
        /**
         * Update the tenant dispute message on a claim
         * @param {string} claimId Claim id
         * @param {UpdateTenantDisputeMessageDTO} updateTenantDisputeMessageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantDisputeMessage(claimId: string, updateTenantDisputeMessageDTO: UpdateTenantDisputeMessageDTO, options?: any) {
            return ClaimsApiFp(configuration).updateTenantDisputeMessage(claimId, updateTenantDisputeMessageDTO, options)(axios, basePath);
        },
        /**
         * Substantiate a Claim on a Tenancy Checkout, before going to the insurer or adjudication 
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyClaim(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).verifyClaim(claimId, options)(axios, basePath);
        },
        /**
         * Waive the Admin Fee for disputing a Claim
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waiveDisputeFee(claimId: string, options?: any) {
            return ClaimsApiFp(configuration).waiveDisputeFee(claimId, options)(axios, basePath);
        },
        /**
         * Generates a zip of all the documents on a claim and sends a message to slack
         * @param {'ADR' | 'INSURER'} type Zip type
         * @param {string} claimId Claim id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zipDocuments(type: 'ADR' | 'INSURER', claimId: string, options?: any) {
            return ClaimsApiFp(configuration).zipDocuments(type, claimId, options)(axios, basePath);
        },
    };
};

/**
 * ClaimsApi - interface
 * @export
 * @interface ClaimsApi
 */
export interface ClaimsApiInterface {
    /**
     * Acknowledge that the case has been sent to the insurer
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    acknowledgeCaseSentToInsurer(claimId: string, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Approve a Claim
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    approveClaim(claimId: string, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Create a Claim
     * @param {CreateClaimDTO} createClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    createClaim(createClaimDTO: CreateClaimDTO, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Capture tenant activity on claim proposal pages
     * @param {string} claimId Claim id
     * @param {CreateClaimActivityDTO} createClaimActivityDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    createClaimActivity(claimId: string, createClaimActivityDTO: CreateClaimActivityDTO, options?: any): AxiosPromise<{}>;

    /**
     * Create an Insurance Claim on a policy for an existing Claim
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    createInsuranceClaimOnClaim(claimId: string, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Mark a Claim as Deactivated
     * @param {string} claimId Claim id 
     * @param {DeactivateClaimDTO} deactivateClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    deactivateClaim(claimId: string, deactivateClaimDTO: DeactivateClaimDTO, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Decline a Claim
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    declineClaim(claimId: string, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Delete a draft, first-round unanswered awaiting-respondents, or deactivated claim and its related records.
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    deleteClaim(claimId: string, options?: any): AxiosPromise<object>;

    /**
     * Get Claim By Id
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    findClaimById(claimId: string, options?: any): AxiosPromise<ClaimWithCheckoutRelationsDTO>;

    /**
     * Generates a PDF ADR form and sends a message to slack
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    generateADRForm(claimId: string, options?: any): AxiosPromise<object>;

    /**
     * Optimised search for Claims
     * @param {string} organizationId Organization Id to filter to by
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {string} [query] Search query
     * @param {string} [claimStatus] Claim Status to filter by
     * @param {string} [sortBy] Sort By to filter by
     * @param {boolean} [includeDeleted] Include deleted claims
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    optimisedSearchClaim(organizationId: string, page: number, size: number, query?: string, claimStatus?: string, sortBy?: string, includeDeleted?: boolean, options?: any): AxiosPromise<SearchClaimResultsDTO>;

    /**
     * Set payment date for an existing claim
     * @param {string} claimId Claim id 
     * @param {PayClaimDTO} payClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    paySupplier(claimId: string, payClaimDTO: PayClaimDTO, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Dry-run a claim deletion: returns what would be deleted and any blocking reasons.
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    previewClaimDeletion(claimId: string, options?: any): AxiosPromise<ClaimDeletionPreviewDto>;

    /**
     * Publish a Claim on a Tenancy Checkout
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    publishClaim(claimId: string, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Set a Claim as ready for Arbitration
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    readyForArbitrateClaim(claimId: string, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Reopen a claim
     * @param {string} claimId Claim id 
     * @param {ReopenClaimDTO} reopenClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    reopenClaim(claimId: string, reopenClaimDTO: ReopenClaimDTO, options?: any): AxiosPromise<ClaimWithCheckoutRelationsDTO>;

    /**
     * Request more from information on a Claim
     * @param {string} claimId Claim id 
     * @param {RequestInfoClaimDTO} requestInfoClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    requestMoreInfoClaim(claimId: string, requestInfoClaimDTO: RequestInfoClaimDTO, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Mark a Claim as Resolved
     * @param {string} claimId Claim id 
     * @param {ResolveClaimDTO} resolveClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    resolveClaim(claimId: string, resolveClaimDTO: ResolveClaimDTO, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Skip Evidence Chaser for a claim
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    skipEvidenceChaser(claimId: string, options?: any): AxiosPromise<object>;

    /**
     * Submit more from information on a Claim
     * @param {string} claimId Claim id 
     * @param {SubmitMoreInfoClaimDTO} submitMoreInfoClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    submitMoreInfoClaim(claimId: string, submitMoreInfoClaimDTO: SubmitMoreInfoClaimDTO, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Set Auto Charge Value For Claim
     * @param {string} claimId Claim id 
     * @param {UpdateAutoChargeClaimDTO} updateAutoChargeClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    updateAutoCharge(claimId: string, updateAutoChargeClaimDTO: UpdateAutoChargeClaimDTO, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Update a Claim
     * @param {string} claimId Claim id 
     * @param {UpdateClaimDTO} updateClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    updateClaim(claimId: string, updateClaimDTO: UpdateClaimDTO, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Update the tenant dispute message on a claim
     * @param {string} claimId Claim id
     * @param {UpdateTenantDisputeMessageDTO} updateTenantDisputeMessageDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    updateTenantDisputeMessage(claimId: string, updateTenantDisputeMessageDTO: UpdateTenantDisputeMessageDTO, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Substantiate a Claim on a Tenancy Checkout, before going to the insurer or adjudication 
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    verifyClaim(claimId: string, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Waive the Admin Fee for disputing a Claim
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    waiveDisputeFee(claimId: string, options?: any): AxiosPromise<ClaimDTO>;

    /**
     * Generates a zip of all the documents on a claim and sends a message to slack
     * @param {'ADR' | 'INSURER'} type Zip type
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    zipDocuments(type: 'ADR' | 'INSURER', claimId: string, options?: any): AxiosPromise<object>;

}

/**
 * ClaimsApi - object-oriented interface
 * @export
 * @class ClaimsApi
 * @extends {BaseAPI}
 */
export class ClaimsApi extends BaseAPI implements ClaimsApiInterface {
    /**
     * Acknowledge that the case has been sent to the insurer
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public acknowledgeCaseSentToInsurer(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).acknowledgeCaseSentToInsurer(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Approve a Claim
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public approveClaim(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).approveClaim(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Create a Claim
     * @param {CreateClaimDTO} createClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public createClaim(createClaimDTO: CreateClaimDTO, options?: any) {
        return ClaimsApiFp(this.configuration).createClaim(createClaimDTO, options)(this.axios, this.basePath);
    }

    /**
     * Capture tenant activity on claim proposal pages
     * @param {string} claimId Claim id
     * @param {CreateClaimActivityDTO} createClaimActivityDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public createClaimActivity(claimId: string, createClaimActivityDTO: CreateClaimActivityDTO, options?: any) {
        return ClaimsApiFp(this.configuration).createClaimActivity(claimId, createClaimActivityDTO, options)(this.axios, this.basePath);
    }

    /**
     * Create an Insurance Claim on a policy for an existing Claim
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public createInsuranceClaimOnClaim(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).createInsuranceClaimOnClaim(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Mark a Claim as Deactivated
     * @param {string} claimId Claim id 
     * @param {DeactivateClaimDTO} deactivateClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public deactivateClaim(claimId: string, deactivateClaimDTO: DeactivateClaimDTO, options?: any) {
        return ClaimsApiFp(this.configuration).deactivateClaim(claimId, deactivateClaimDTO, options)(this.axios, this.basePath);
    }

    /**
     * Decline a Claim
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public declineClaim(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).declineClaim(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Delete a draft, first-round unanswered awaiting-respondents, or deactivated claim and its related records.
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public deleteClaim(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).deleteClaim(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Get Claim By Id
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public findClaimById(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).findClaimById(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Generates a PDF ADR form and sends a message to slack
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public generateADRForm(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).generateADRForm(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Optimised search for Claims
     * @param {string} organizationId Organization Id to filter to by
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {string} [query] Search query
     * @param {string} [claimStatus] Claim Status to filter by
     * @param {string} [sortBy] Sort By to filter by
     * @param {boolean} [includeDeleted] Include deleted claims
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public optimisedSearchClaim(organizationId: string, page: number, size: number, query?: string, claimStatus?: string, sortBy?: string, includeDeleted?: boolean, options?: any) {
        return ClaimsApiFp(this.configuration).optimisedSearchClaim(organizationId, page, size, query, claimStatus, sortBy, includeDeleted, options)(this.axios, this.basePath);
    }

    /**
     * Set payment date for an existing claim
     * @param {string} claimId Claim id 
     * @param {PayClaimDTO} payClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public paySupplier(claimId: string, payClaimDTO: PayClaimDTO, options?: any) {
        return ClaimsApiFp(this.configuration).paySupplier(claimId, payClaimDTO, options)(this.axios, this.basePath);
    }

    /**
     * Dry-run a claim deletion: returns what would be deleted and any blocking reasons.
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public previewClaimDeletion(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).previewClaimDeletion(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Publish a Claim on a Tenancy Checkout
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public publishClaim(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).publishClaim(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Set a Claim as ready for Arbitration
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public readyForArbitrateClaim(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).readyForArbitrateClaim(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Reopen a claim
     * @param {string} claimId Claim id 
     * @param {ReopenClaimDTO} reopenClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public reopenClaim(claimId: string, reopenClaimDTO: ReopenClaimDTO, options?: any) {
        return ClaimsApiFp(this.configuration).reopenClaim(claimId, reopenClaimDTO, options)(this.axios, this.basePath);
    }

    /**
     * Request more from information on a Claim
     * @param {string} claimId Claim id 
     * @param {RequestInfoClaimDTO} requestInfoClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public requestMoreInfoClaim(claimId: string, requestInfoClaimDTO: RequestInfoClaimDTO, options?: any) {
        return ClaimsApiFp(this.configuration).requestMoreInfoClaim(claimId, requestInfoClaimDTO, options)(this.axios, this.basePath);
    }

    /**
     * Mark a Claim as Resolved
     * @param {string} claimId Claim id 
     * @param {ResolveClaimDTO} resolveClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public resolveClaim(claimId: string, resolveClaimDTO: ResolveClaimDTO, options?: any) {
        return ClaimsApiFp(this.configuration).resolveClaim(claimId, resolveClaimDTO, options)(this.axios, this.basePath);
    }

    /**
     * Skip Evidence Chaser for a claim
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public skipEvidenceChaser(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).skipEvidenceChaser(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Submit more from information on a Claim
     * @param {string} claimId Claim id 
     * @param {SubmitMoreInfoClaimDTO} submitMoreInfoClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public submitMoreInfoClaim(claimId: string, submitMoreInfoClaimDTO: SubmitMoreInfoClaimDTO, options?: any) {
        return ClaimsApiFp(this.configuration).submitMoreInfoClaim(claimId, submitMoreInfoClaimDTO, options)(this.axios, this.basePath);
    }

    /**
     * Set Auto Charge Value For Claim
     * @param {string} claimId Claim id 
     * @param {UpdateAutoChargeClaimDTO} updateAutoChargeClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public updateAutoCharge(claimId: string, updateAutoChargeClaimDTO: UpdateAutoChargeClaimDTO, options?: any) {
        return ClaimsApiFp(this.configuration).updateAutoCharge(claimId, updateAutoChargeClaimDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update a Claim
     * @param {string} claimId Claim id 
     * @param {UpdateClaimDTO} updateClaimDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public updateClaim(claimId: string, updateClaimDTO: UpdateClaimDTO, options?: any) {
        return ClaimsApiFp(this.configuration).updateClaim(claimId, updateClaimDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update the tenant dispute message on a claim
     * @param {string} claimId Claim id
     * @param {UpdateTenantDisputeMessageDTO} updateTenantDisputeMessageDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public updateTenantDisputeMessage(claimId: string, updateTenantDisputeMessageDTO: UpdateTenantDisputeMessageDTO, options?: any) {
        return ClaimsApiFp(this.configuration).updateTenantDisputeMessage(claimId, updateTenantDisputeMessageDTO, options)(this.axios, this.basePath);
    }

    /**
     * Substantiate a Claim on a Tenancy Checkout, before going to the insurer or adjudication 
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public verifyClaim(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).verifyClaim(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Waive the Admin Fee for disputing a Claim
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public waiveDisputeFee(claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).waiveDisputeFee(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Generates a zip of all the documents on a claim and sends a message to slack
     * @param {'ADR' | 'INSURER'} type Zip type
     * @param {string} claimId Claim id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public zipDocuments(type: 'ADR' | 'INSURER', claimId: string, options?: any) {
        return ClaimsApiFp(this.configuration).zipDocuments(type, claimId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ClaimsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Acknowledge that the case has been sent to the insurer
 * @param {string} claimId Claim id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function acknowledgeCaseSentToInsurer(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).acknowledgeCaseSentToInsurer(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Approve a Claim
 * @param {string} claimId Claim id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function approveClaim(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).approveClaim(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create a Claim
 * @param {CreateClaimDTO} createClaimDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createClaim(
    createClaimDTO: CreateClaimDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).createClaim(createClaimDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Capture tenant activity on claim proposal pages
 * @param {string} claimId Claim id
 * @param {CreateClaimActivityDTO} createClaimActivityDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createClaimActivity(
    claimId: string,
    createClaimActivityDTO: CreateClaimActivityDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).createClaimActivity(claimId, createClaimActivityDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create an Insurance Claim on a policy for an existing Claim
 * @param {string} claimId Claim id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createInsuranceClaimOnClaim(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).createInsuranceClaimOnClaim(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Mark a Claim as Deactivated
 * @param {string} claimId Claim id 
 * @param {DeactivateClaimDTO} deactivateClaimDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deactivateClaim(
    claimId: string,
    deactivateClaimDTO: DeactivateClaimDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).deactivateClaim(claimId, deactivateClaimDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Decline a Claim
 * @param {string} claimId Claim id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function declineClaim(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).declineClaim(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a draft, first-round unanswered awaiting-respondents, or deactivated claim and its related records.
 * @param {string} claimId Claim id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteClaim(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).deleteClaim(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get Claim By Id
 * @param {string} claimId Claim id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findClaimById(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimWithCheckoutRelationsDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).findClaimById(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Generates a PDF ADR form and sends a message to slack
 * @param {string} claimId Claim id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function generateADRForm(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).generateADRForm(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Optimised search for Claims
 * @param {string} organizationId Organization Id to filter to by
 * @param {number} page Page to start on (defaults to 1)
 * @param {number} size Size of result set to return (defaults to 15)
 * @param {string} [query] Search query
 * @param {string} [claimStatus] Claim Status to filter by
 * @param {string} [sortBy] Sort By to filter by
 * @param {boolean} [includeDeleted] Include deleted claims
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function optimisedSearchClaim(
    organizationId: string,
    page: number,
    size: number,
    query?: string,
    claimStatus?: string,
    sortBy?: string,
    includeDeleted?: boolean,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SearchClaimResultsDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).optimisedSearchClaim(organizationId, page, size, query, claimStatus, sortBy, includeDeleted, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Set payment date for an existing claim
 * @param {string} claimId Claim id 
 * @param {PayClaimDTO} payClaimDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function paySupplier(
    claimId: string,
    payClaimDTO: PayClaimDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).paySupplier(claimId, payClaimDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Dry-run a claim deletion: returns what would be deleted and any blocking reasons.
 * @param {string} claimId Claim id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function previewClaimDeletion(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDeletionPreviewDto> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).previewClaimDeletion(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Publish a Claim on a Tenancy Checkout
 * @param {string} claimId Claim id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function publishClaim(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).publishClaim(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Set a Claim as ready for Arbitration
 * @param {string} claimId Claim id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function readyForArbitrateClaim(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).readyForArbitrateClaim(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Reopen a claim
 * @param {string} claimId Claim id 
 * @param {ReopenClaimDTO} reopenClaimDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function reopenClaim(
    claimId: string,
    reopenClaimDTO: ReopenClaimDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimWithCheckoutRelationsDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).reopenClaim(claimId, reopenClaimDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Request more from information on a Claim
 * @param {string} claimId Claim id 
 * @param {RequestInfoClaimDTO} requestInfoClaimDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function requestMoreInfoClaim(
    claimId: string,
    requestInfoClaimDTO: RequestInfoClaimDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).requestMoreInfoClaim(claimId, requestInfoClaimDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Mark a Claim as Resolved
 * @param {string} claimId Claim id 
 * @param {ResolveClaimDTO} resolveClaimDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function resolveClaim(
    claimId: string,
    resolveClaimDTO: ResolveClaimDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).resolveClaim(claimId, resolveClaimDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Skip Evidence Chaser for a claim
 * @param {string} claimId Claim id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function skipEvidenceChaser(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).skipEvidenceChaser(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Submit more from information on a Claim
 * @param {string} claimId Claim id 
 * @param {SubmitMoreInfoClaimDTO} submitMoreInfoClaimDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function submitMoreInfoClaim(
    claimId: string,
    submitMoreInfoClaimDTO: SubmitMoreInfoClaimDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).submitMoreInfoClaim(claimId, submitMoreInfoClaimDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Set Auto Charge Value For Claim
 * @param {string} claimId Claim id 
 * @param {UpdateAutoChargeClaimDTO} updateAutoChargeClaimDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateAutoCharge(
    claimId: string,
    updateAutoChargeClaimDTO: UpdateAutoChargeClaimDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).updateAutoCharge(claimId, updateAutoChargeClaimDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update a Claim
 * @param {string} claimId Claim id 
 * @param {UpdateClaimDTO} updateClaimDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateClaim(
    claimId: string,
    updateClaimDTO: UpdateClaimDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).updateClaim(claimId, updateClaimDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update the tenant dispute message on a claim
 * @param {string} claimId Claim id
 * @param {UpdateTenantDisputeMessageDTO} updateTenantDisputeMessageDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateTenantDisputeMessage(
    claimId: string,
    updateTenantDisputeMessageDTO: UpdateTenantDisputeMessageDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).updateTenantDisputeMessage(claimId, updateTenantDisputeMessageDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Substantiate a Claim on a Tenancy Checkout, before going to the insurer or adjudication 
 * @param {string} claimId Claim id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function verifyClaim(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).verifyClaim(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Waive the Admin Fee for disputing a Claim
 * @param {string} claimId Claim id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function waiveDisputeFee(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDTO> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).waiveDisputeFee(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Generates a zip of all the documents on a claim and sends a message to slack
 * @param {'ADR' | 'INSURER'} type Zip type
 * @param {string} claimId Claim id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function zipDocuments(
    type: 'ADR' | 'INSURER',
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = ClaimsApiAxiosParamCreator(configuration).zipDocuments(type, claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

